// @flow
import styled, { css } from "styled-components";
import { media } from "@nested/brand";
import { StampDutyForm } from "./StampDutyForm";
import { RichText } from "../RichText/RichText";
import { regularHeading, mediumHeading } from "../Typography/Headings";

const wrapperStyle = css`
  padding: 0px 10px;
  margin: auto;
  max-width: 500px;
`;

const Title = styled(RichText)`
  & > h2 {
    ${regularHeading}
    ${media.tablet`
      ${mediumHeading}
      margin-bottom: 30px;
    `}
    text-align: center;
    margin-top: 0;
  }
`;

type Props = {
  introductionText: PrismicRichText,
  title: PrismicRichText,
  buttonText: string,
};

export const StampDutyCalculator = ({
  title,
  introductionText,
  buttonText,
}: Props) => {
  return (
    <div css={wrapperStyle}>
      <div css="text-align: center">
        <Title>{title}</Title>
      </div>
      <StampDutyForm
        introductionText={introductionText}
        buttonText={buttonText}
      />
    </div>
  );
};
